import { render } from "./company_info.vue?vue&type=template&id=650ae70e"
import script from "./company_info.vue?vue&type=script&lang=js"
export * from "./company_info.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/vkursi/company_info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "650ae70e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('650ae70e', __exports__)) {
    console.log('reload')
    api.reload('650ae70e', __exports__)
  }
  
  module.hot.accept("./company_info.vue?vue&type=template&id=650ae70e", () => {
    console.log('re-render')
    api.rerender('650ae70e', render)
  })

}


export default __exports__